import type { FaireProductEntity } from "../../entity_types/product";

export const p_4ftttka3bu: FaireProductEntity = {
  token: "p_4ftttka3bu",
  type: "product",
  name: "Infant Girls White and Pink Bow Baby Gown",
  brandToken: "b_dlso2ccw88",
  brandName: "Adorable Sweetness",
  imageUrl:
    "https://cdn.faire.com/fastly/019849c09cf77ad4b42bf2b69b4c9d4d768fbeb8961bb7140bc991952e406fc6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d2ee937bac268e35be0840eccecb96be13fbe9bb77e7a1e06af71dd71d45d056.jpeg",
    "https://cdn.faire.com/fastly/edbe4c0ad8c4d6579b53064285e7c3632797ff44f047b12b7fc21b425e3a044d.jpeg",
    "https://cdn.faire.com/fastly/dcfaf8dc1b99b9ac7442b661d7f29887b2228bb87b9e5306959310ff5cc8ed73.jpeg",
  ],
  priceDollars: 10,
  description:
    "Size is 0-3 Months\nIncludes a free matching Bow!\n\nEnjoy this adorable Infant Girls Pink Bow print sleep gown for your precious new arrival. Our gowns are made of a quality 95% polyester and 5% spandex blend that leaves your babe feeling super soft & incredibly cozy. The sturdy elastic at the bottom allows parents quick access for diaper changes and will keep little toes tucked in during all hours of the day and night.\n\n95% polyester and 5% spandex",
  tags: [],
  msrpDollars: 19.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:10.697Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
